module.exports = __webpack_public_path__ + "static/media/freshgrocer_internal_demo_page_back_of_card.ec77fb5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshgrocer_internal_demo_page_back_of_card.png
// module id = 353
// module chunks = 0